/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Alert, CornerDialog, ListItem, Pane, UnorderedList,
} from 'evergreen-ui';

type DialogError = {
  errors: string[],
  closeDialog: () => void
}
/**
 * @param {string[]} param.errors массив ошибок
 * @param {Function} param.closeDialog функция, котрая вызывается при закрытии диалога
 * @example
 * <CornerDialogError errors={errors} closeDialog={()=> setErrors([]))} />
 */
export default function CornerDialogError({ errors, closeDialog }: DialogError) {
  const containerProps = React.useMemo(() => ({
    borderLeft: '4px solid #ec4c47',
    paddingLeft: '22px', // padding+border
    padding: '18px',
    zIndex: 100,
  }), []);

  if (!errors?.length) return null;
  return (
    <CornerDialog
      title="Ошибка"
      isShown={!!errors.length}
      hasFooter={false}
      onCloseComplete={closeDialog}
      containerProps={containerProps}
    >
      <Pane maxHeight="200px">
        <UnorderedList>
          {errors.map((err, idx) => <ListItem key={idx}>{err}</ListItem>)}
        </UnorderedList>
      </Pane>
    </CornerDialog>
  );
}
/**
 * @param {string[]} param.errors массив ошибок
 * @param {Function} param.closeAlert функция, котрая вызывается при закрытии алерта
 * @example
 * <AlertError errors={errors} closeAlert={()=> setErrors([]))} />
 */
export function AlertError({ errors, closeAlert }: any) {
  if (!errors?.length) return null;
  return (
    <Alert
      intent="danger"
      title="Ошибка"
      isRemoveable
      onRemove={closeAlert}
    >
      <Pane maxHeight="150px" overflow="auto">
        <UnorderedList>
          {errors.map((err: any) => <ListItem key={err}>{err}</ListItem>)}
        </UnorderedList>
      </Pane>
    </Alert>
  );
}
